import {
    PRODUCT_FILTERING_RECEIVE,
  } from '../constants';
  
  const defaultState = {
    facetFilters: [],
    filtersCollapsedByDefault: false,
  };
  
  export const productFiltering = (state = defaultState, action) => {
    const { type, payload } = action;
  
    switch (type) {

      case PRODUCT_FILTERING_RECEIVE:
        return {
          ...state,
          ...payload,
        };
  
      default:
        return state;
    }
  };
  